(function () {
  function ready(fn) {
    if (document.readyState != 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }
  ready(function () {
    var input = document.querySelector('input[name="q-instant-search"]');
    var grid =
      document.getElementById('pnm-collection-grid') ||
      document.querySelector('.grid-flex.filter_enable_hide');
    if (!input || !grid) return;
    var items = Array.prototype.slice
      .call(
        grid.querySelectorAll(
          '.grid-flex__item, .one-quarter, .product-grid-item'
        )
      )
      .filter(function (it) {
        return !!it.querySelector('.product-block');
      });
    items.forEach(function (it) {
      var block = it.querySelector('.product-block');
      var title =
        (
          block.querySelector(
            '.product-block__title, .product-block__title-link, .h5, a'
          ) || {}
        ).textContent || '';
      var vendor =
        (block.querySelector('.product-block__vendor') || {}).textContent || '';
      var desc =
        (block.querySelector('.rte, .product-excerpt') || {}).textContent || '';
      block.setAttribute(
        'data-pnm-hay',
        (title + ' ' + vendor + ' ' + desc)
          .toLowerCase()
          .replace(/\s+/g, ' ')
          .trim()
      );
    });
    function apply(q) {
      q = (q || '').toLowerCase().trim();
      var tokens = q.split(/\s+/).filter(Boolean);
      items.forEach(function (it) {
        var hay =
          (it.querySelector('.product-block') || it).getAttribute(
            'data-pnm-hay'
          ) || '';
        var ok = tokens.every(function (t) {
          return hay.indexOf(t) !== -1;
        });
        it.style.display = q && !ok ? 'none' : '';
      });
    }
    input.addEventListener('input', function (e) {
      apply(e.target.value);
    });
  });
})();
